import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { useFieldContext } from '@zealth/core/form/contexts'
import type { DateFormFieldProps } from '@zealth/core/formFields/types'
import { setDate, setMonth } from 'date-fns'
import { Timestamp } from 'firebase/firestore'

const viewsByMode = {
  year_month_day: ['year', 'month', 'day'],
  year_month: ['year', 'month'],
  year: ['year'],
} as const

export const DateFormField = ({
  label,
  optional,
  minDate,
  maxDate,
  mode = 'year_month',
  defaultDay = 1,
  defaultMonth = 1,
}: DateFormFieldProps) => {
  const field = useFieldContext<Timestamp | null>()

  const timestampToDate = (ts: Timestamp) => {
    let date = ts.toDate()
    if (mode === 'year_month') {
      date = setDate(date, defaultDay)
    }
    if (mode === 'year') {
      date = setDate(date, defaultDay)
      date = setMonth(date, defaultMonth - 1)
    }
    return date
  }

  const dateToTimestamp = (date: Date) => {
    return Timestamp.fromDate(date)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={label}
        views={viewsByMode[mode]}
        openTo="year"
        minDate={minDate}
        maxDate={maxDate}
        value={field.state.value ? timestampToDate(field.state.value) : null}
        slotProps={{
          textField: {
            fullWidth: true,
            required: !optional,
            error: field.state.meta.errors.length > 0,
            helperText: field.state.meta.errors[0]?.message ?? ' ',
          },
        }}
        onChange={value =>
          field.handleChange(value ? dateToTimestamp(value) : null)
        }
      />
    </LocalizationProvider>
  )
}
